export function emulatorReducer(state, action) {
    switch(action.type) {
        default:
            return { ...state };
    }   
}